import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import de from './locales/de.json';
import en from './locales/en.json';
import bs from './locales/bs.json';
import hr from './locales/hr.json';
import mk from './locales/mk.json';
import srCyrl from './locales/sr-Cyrl.json';
import sr from './locales/sr.json';

export const LANGUAGES = [
  { code: 'de', label: 'Deutsch' },
  { code: 'en', label: 'English' },
  { code: 'bs', label: 'Bosanski' },
  { code: 'hr', label: 'Hrvatski' },
  { code: 'mk', label: 'Македонски' },
  { code: 'sr-Cyrl', label: 'Српски (ћирилица)' },
  { code: 'sr', label: 'Srpski (latinica)' },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]['code'];

const LANG_STORAGE_KEY = 'suton-language';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      bs: { translation: bs },
      hr: { translation: hr },
      mk: { translation: mk },
      'sr-Cyrl': { translation: srCyrl },
      sr: { translation: sr },
    },
    fallbackLng: 'de',
    lng: typeof localStorage !== 'undefined' ? localStorage.getItem(LANG_STORAGE_KEY) || 'de' : 'de',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANG_STORAGE_KEY, lng);
});

export default i18n;
